import {GameBadgeDefaultBox} from './game-badge.default.box';
import {styledByTheme} from '../../../../../themes/architecture/styled-by-theme';
import {GameBadgeCasino777Box} from './game-badge.casino777.box';
import {GameBadgeSIBox} from './game-badge.si.box';

export const GameBadgeBox = styledByTheme(GameBadgeDefaultBox)
    .forCasino777(GameBadgeCasino777Box)
    .forSI(GameBadgeSIBox)
    .forMrGreen(GameBadgeSIBox).apply();

